import { IconProps } from '../icons';
import { themeColors } from '@styles/theme';

export const CreateSelectionSetIcon = ({
    width = 24,
    height = 24,
    color = themeColors.grey,
}: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="3.5"
                y="3.5"
                width="17"
                height="17"
                rx="2"
                stroke={color}
                strokeWidth="1.5"
                strokeDasharray="3 2"
            />
            <path
                d="M12 8.25V15.75M8.25 12H15.75"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};
